import React, { FC } from 'react';

export const AuthTerms: FC = (): JSX.Element => {
  return (
    <p className="auth-page-terms-and-policy">
      By using Scrnli, you agree to the&nbsp;
      <a href="#" className="link">Terms of Service</a>
      &nbsp;and&nbsp;
      <a href="#" className="link">Privacy Policy</a>
      &nbsp;of Scrnli service.
    </p>
  );
};

export default AuthTerms;
